// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "AccomplishmentModal__buttonWrapper__60vj+";
export const closeButtonWrapper = "AccomplishmentModal__closeButtonWrapper__WIVvf";
export const content = "AccomplishmentModal__content__hdj2Q";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const icon = "AccomplishmentModal__icon__808ux";
export const iconWrapper = "AccomplishmentModal__iconWrapper__FLhe6";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const text = "AccomplishmentModal__text__QOQxu font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const title = "AccomplishmentModal__title__4OV8y font-faces__serifMedium__n-4rV font-faces__serif__XseuP";